import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

$(function () {
  
  $('.dropdown .heading').on('click', function(){
    var Parent = $(this).parent('.item');
    $('.content', Parent).slideToggle();
    Parent.toggleClass('active');
  });
  

  $('.owl-suburb-profiles').owlCarousel({
    loop: true,
    dots: false,
    items: 1,
    margin: 0,
    mouseDrag: false,
  });
  $('.owl-recently-sold').owlCarousel({
    loop: true,
    dots: false,
    items: 3,
    margin: 5,
    mouseDrag: false,
    responsive : {
      // breakpoint from 0 up
      0 : {
        items: 1,
      },
      480 : {
        items: 2,
      },
      1024 : {
        items: 3,
      },
    }
  });
  $('.owl-individual-property').owlCarousel({
    loop: true,
    dots: true,
    items: 1,
    margin: 0,
    mouseDrag: false,
    nav: false,
  });
  $('.owl-suburb-profile-page').owlCarousel({
    loop: true,
    dots: true,
    items: 1,
    margin: 0,
    mouseDrag: false,
    nav: false,
  });
  $('.owl-other-local-suburb').owlCarousel({
    loop: true,
    dots: false,
    items: 4,
    margin: 5,
    mouseDrag: false,
    nav: true,
    responsive : {
      // breakpoint from 0 up
      0 : {
        items: 1,
      },
      640 : {
        items: 2,
      },
      1024 : {
        items: 4,
      },
    }
  });

  $('.owl-our-properties').owlCarousel({
    loop: true,
    dots: false,
    items: 4,
    margin: 5,
    mouseDrag: false,
    nav: true,
    responsive : {
      // breakpoint from 0 up
      0 : {
        items: 1,
      },
      640 : {
        items: 2,
      },
      1024 : {
        items: 4,
      },
    }
  });
  $('.owl-testimonials').owlCarousel({
    loop: true,
    dots: false,
    items: 1,
    margin: 50,
    mouseDrag: false,
    nav: true,
  });

  
});
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();



     